import IDMGlobals from './../../IDMGlobals';
//
export default class APIAuthorization {
  constructor(API) {
    this.api = API;
  }
  async login(username, password, optionalMFA, linkingRoles, timestamp) {
    const req = await this.api.newBaseRequest('POST', true /*allows role impersonation*/);
    req.path = IDMGlobals.APIPath_Login;
    req.body = { username, password, ...(optionalMFA ? { mfa: optionalMFA } : {}), linkingRoles, timestamp };
    return await req.exec();
  }
  async logout() {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_Logout;
    return await req.exec();
  }
  async validate(token, username, timestamp) {
    const req = await this.api.newBaseRequest('POST', false, true);
    req.path = IDMGlobals.APIPath_Validate;
    req.body = { token: token, username, timestamp };
    return await req.exec();
  }
  /* Federation */
  async loginFederation(code, redirectURL, linkingRoles) {
    const req = await this.api.newBaseRequest('POST', true /*allows role impersonation*/);
    req.path = IDMGlobals.APIPath_Login + '/federation';
    req.body = { code, redirectURL, linkingRoles };
    return await req.exec();
  }
  /* SSO Code */
  async loginSSO(code) {
    const req = await this.api.newBaseRequest('POST', true /*allows role impersonation*/);
    req.path = IDMGlobals.APIPath_Login + '/sso';
    req.body = { code };
    return await req.exec();
  }
  async generateSSOCode(userID) {
    const req = await this.api.newBaseRequest('POST', true /*allows role impersonation*/);
    req.path = '/sso';
    req.body = { userID };
    return await req.exec();
  }

  /* Custom challenge */
  async answerChallenge(challengeObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_Challenge;
    req.body = challengeObj;
    return await req.exec();
  }
}
